const random_id = function(length = 6) {
  return Math.random().toString(36).substring(2, length+2);
};
const state_ctrl_factory = function(service_name, onChangeChartParams) {
    const ctrl = function(service_api, $scope, chartFilters) {
        $scope.vm = {};
        const _onChangeChartParams = (model) => onChangeChartParams(service_api, $scope, model);
        _onChangeChartParams(chartFilters.get_chart_filters());
        chartFilters.onChangeChartParams(random_id(), _onChangeChartParams);
    };
    ctrl.$inject = [service_name, '$scope', 'chartFilters'];
    return ctrl;
};
const state_ctrl_factory_method = function(method_id, onMethodSuccess) {
    return state_ctrl_factory('jsonrpc', function(jsonrpc, $scope, model) {
        return jsonrpc
          .callServiceMethod(method_id, model)
          .then(resp => onMethodSuccess($scope, resp));
    });
};
export {
    random_id,
    state_ctrl_factory,
    state_ctrl_factory_method,
}
